"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4296],{

/***/ 34296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11719);
/* harmony import */ var _components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53056);
/* harmony import */ var _components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62412);
/* harmony import */ var _utility_cr_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46236);
/* harmony import */ var _material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44080);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34853);
/* harmony import */ var _components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97344);
/* harmony import */ var _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66306);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5969);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31955);
/* harmony import */ var _components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98950);
/* harmony import */ var _utility_services_customHooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89147);
/* harmony import */ var _components_CreditsInfo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98910);
/* harmony import */ var _utility_tools_config__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92061);



















var useStyles = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(theme) {
    return {
        buttonGroup: {
            display: "flex",
            justifyContent: "flex-end"
        }
    };
});
var AnchorTextGenerator = function(param) {
    var classes = param.classes, setShowSignUpPage = param.setShowSignUpPage, user = param.user, hasValidSubscription = param.hasValidSubscription, resetLockedGrace = param.resetLockedGrace, enableLockedOption = param.enableLockedOption, handleResetUsage = param.handleResetUsage, _isQwaDashboard = param.isQwaDashboard, isQwaDashboard = _isQwaDashboard === void 0 ? false : _isQwaDashboard, _isCreditsShown = param.isCreditsShown, isCreditsShown = _isCreditsShown === void 0 ? false : _isCreditsShown, _creditsRemaining = param.creditsRemaining, creditsRemaining = _creditsRemaining === void 0 ? 0 : _creditsRemaining, _usagePerDay = param.usagePerDay, usagePerDay = _usagePerDay === void 0 ? 0 : _usagePerDay, setShowBuyOnePass = param.setShowBuyOnePass, setIsRedirectToWebflow = param.setIsRedirectToWebflow, _setShowMinimumCreditsNeededMsg = param.setShowMinimumCreditsNeededMsg, setShowMinimumCreditsNeededMsg = _setShowMinimumCreditsNeededMsg === void 0 ? function(a) {} : _setShowMinimumCreditsNeededMsg, setShowVerifyEmailPopup = param.setShowVerifyEmailPopup, _freeToolsUsage = param.freeToolsUsage, freeToolsUsage = _freeToolsUsage === void 0 ? 0 : _freeToolsUsage, _showFreeToolsUsage = param.showFreeToolsUsage, showFreeToolsUsage = _showFreeToolsUsage === void 0 ? false : _showFreeToolsUsage, _isCorpEmail = param.isCorpEmail, isCorpEmail = _isCorpEmail === void 0 ? false : _isCorpEmail;
    var ownClasses = useStyles();
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), pageURL = ref1[0], setPageURL = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(3), numTags = ref2[0], setNumTags = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), generatedTitles = ref3[0], setGeneratedTitles = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), error = ref5[0], setError = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), copied = ref6[0], setCopied = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), recaptchaValue = ref7[0], setRecaptchaValue = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), captchaError = ref8[0], setCaptchaError = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), creditsNeeded = ref9[0], setCreditsNeeded = ref9[1];
    var inputSelectionRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_12__/* .useSession */ .kP)();
    var handleRecaptchaChange = function(value) {
        setRecaptchaValue(value);
        setCaptchaError("");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
            isAnonymousUser: !user,
            payload: {
                label: "Visited Free Tool",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                isQwaDashboard: isQwaDashboard
            }
        });
    }, []);
    var handleWriteTitleTag = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var isInputValid, res, axiosError;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        isInputValid = keyword && pageURL;
                        if (isInputValid) {
                            _ctx.next = 6;
                            break;
                        }
                        setError("Both keyword and pageURL are required");
                        return _ctx.abrupt("return");
                    case 6:
                        if (!(!keyword || !pageURL)) {
                            _ctx.next = 9;
                            break;
                        }
                        setError(!keyword ? "keyword" : "pageURL");
                        return _ctx.abrupt("return");
                    case 9:
                        if (recaptchaValue || qttr_tools_auth || user) {
                            _ctx.next = 12;
                            break;
                        }
                        setCaptchaError("recaptchaValue");
                        return _ctx.abrupt("return");
                    case 12:
                        setCaptchaError("");
                        setError("");
                        _ctx.next = 16;
                        return (0,_utility_cr_common__WEBPACK_IMPORTED_MODULE_5__/* .fetchAIBasedContent */ .LK)({
                            promptFor: "PUBLIC_UTILITY.GENERATE_ANCHOR_TEXT",
                            promptConfig: {
                                noOf: numTags,
                                pageURL: pageURL,
                                topic: keyword
                            },
                            tokenLimit: 3500,
                            isPublicApi: true,
                            reCAPTCHAToken: recaptchaValue
                        });
                    case 16:
                        res = _ctx.sent;
                        if (res) {
                            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                eventFor: "button",
                                buttonText: "",
                                counterName: "".concat(_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization, " Outputs"),
                                isAddCount: true,
                                user: user,
                                isAnonymousUser: !user,
                                payload: {
                                    label: "Generate Output",
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                                    number_suggestions: numTags,
                                    isQwaDashboard: isQwaDashboard,
                                    creditsConsumed: creditsNeeded ? creditsNeeded : 1
                                }
                            });
                            if (handleResetUsage) {
                                handleResetUsage();
                            }
                        }
                        setGeneratedTitles(res || "no title generated");
                        if (resetLockedGrace) {
                            resetLockedGrace();
                            setNumTags(3);
                        }
                        _ctx.next = 27;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](0);
                        axiosError = _ctx.t0;
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            if (axiosError.response.status === 403) {
                                setShowSignUpPage(_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_7__/* .CONTINUE_USING_TEXT */ .gt, {
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                                });
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    buttonText: "",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Reached your maximum usage limit",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                                        isQwaDashboard: isQwaDashboard
                                    }
                                });
                            }
                        }
                        console.error("handleWriteTitleTag::error", _ctx.t0);
                    case 27:
                        _ctx.prev = 27;
                        setRecaptchaValue(null);
                        (0,_utility_common__WEBPACK_IMPORTED_MODULE_9__/* .resetCaptcha */ .Ler)();
                        setLoading(false);
                        return _ctx.finish(27);
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    22,
                    27,
                    32
                ]
            ]);
        }));
        return function handleWriteTitleTag() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCopyText = function() {
        var inputElement = inputSelectionRef === null || inputSelectionRef === void 0 ? void 0 : inputSelectionRef.current;
        if (inputElement) {
            var ref;
            var copiedText = inputElement === null || inputElement === void 0 ? void 0 : (ref = inputElement.value) === null || ref === void 0 ? void 0 : ref.substring((inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionStart) || 0, (inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionEnd) || 0);
            if (copiedText) {
                setCopied(true);
                navigator.clipboard.writeText(copiedText);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                        number_suggestions: numTags,
                        isQwaDashboard: isQwaDashboard,
                        isManualCopy: true
                    }
                });
            } else {
                navigator.clipboard.writeText(generatedTitles);
                setCopied(true);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                        number_suggestions: numTags,
                        isQwaDashboard: isQwaDashboard
                    }
                });
            }
            setTimeout(function() {
                setCopied(false);
            }, 2000); // Change the text back to 'Copy Text' after 2 seconds
        }
    };
    var numbers = [
        3,
        5,
        10
    ];
    // Convert the array items to a mixed array of a number and objects
    var NumberOptions = numbers.map(function(number) {
        // Keep the first item as a number
        if ([
            3
        ].includes(number)) {
            return number;
        }
        // Convert the rest to objects, include a React component for the icon
        return {
            name: number,
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utility_tools_config__WEBPACK_IMPORTED_MODULE_14__/* .PremiumToolsIcon */ .WL, {})
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var promptFor = _utility_common__WEBPACK_IMPORTED_MODULE_9__/* .PAID_TOOLS_PROMPT_FOR.ANCHOR_TEXT_GENERATOR */ .rMq.ANCHOR_TEXT_GENERATOR;
        var promptConfig = {
            noOf: numTags,
            pageURL: pageURL,
            topic: keyword
        };
        setCreditsNeeded((0,_utility_common__WEBPACK_IMPORTED_MODULE_9__/* .getToolsUsageCreditsNeeded */ .Nmb)(promptFor, promptConfig));
    }, [
        user,
        keyword,
        numTags,
        pageURL
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: generatedTitles ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    inputRef: inputSelectionRef,
                    fullWidth: true,
                    multiline: true,
                    rows: 8,
                    margin: "normal",
                    placeholder: "Generated Title Tag",
                    value: generatedTitles,
                    className: "".concat(classes.textAreaInput, " no-border background-gray"),
                    maxRows: 8,
                    InputProps: {
                        style: {
                            borderRadius: "4px !important",
                            padding: "16px"
                        }
                    },
                    minRows: 5,
                    variant: "outlined",
                    onCopy: handleCopyText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: classes.buttonGroup,
                    style: {
                        marginTop: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, " ").concat(classes.button),
                            disabled: loading,
                            style: {
                                float: "right"
                            },
                            onClick: function() {
                                setGeneratedTitles("");
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                    eventName: "Clicked on Go back",
                                    payload: {
                                        label: "Clicked on Go back"
                                    }
                                });
                            },
                            children: "Go back"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                            disabled: loading,
                            style: {
                                float: "right"
                            },
                            onClick: handleCopyText,
                            children: copied ? "Copied!" : "Copy Text"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: classes.container,
                children: [
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_3__/* .QuattrLogoSpinner */ .h, {
                        classes: classes
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        fullWidth: true,
                        label: "Enter Main Keyword or Page Topic",
                        value: keyword,
                        className: "".concat(classes.textAreaInput, " no-border mb-0"),
                        onChange: function(e) {
                            return setKeyword(e.target.value);
                        },
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important"
                            }
                        },
                        variant: "outlined",
                        error: !!error,
                        helperText: error.includes("keyword") ? "* Required" : error.includes("Please sign up") ? error : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        fullWidth: true,
                        label: "Enter Page URL",
                        value: pageURL,
                        className: "".concat(classes.textAreaInput, " no-border"),
                        onChange: function(e) {
                            return setPageURL(e.target.value);
                        },
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important"
                            }
                        },
                        variant: "outlined",
                        error: !!error,
                        helperText: error.includes("pageURL") ? "* Required" : error.includes("Please sign up") ? error : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        label: "Number of Anchor Text Suggestions",
                        value: numTags,
                        options: NumberOptions,
                        classes: classes,
                        onChange: function(event) {
                            var value = event.target.value;
                            var option = NumberOptions.find(function(o) {
                                return typeof o === "object" && "name" in o ? o.name === value : o === value;
                            });
                            if (option && (typeof option === "number" || !(typeof option == "object" && option.requireLogin))) {
                                setNumTags(value);
                            } else {
                                if (setShowSignUpPage) {
                                    setShowSignUpPage("'enable ".concat(value, " anchor text suggestions'"), {
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                                    });
                                    (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec)({
                                        eventFor: "button",
                                        buttonText: "",
                                        isAnonymousUser: !user,
                                        payload: {
                                            label: "Clicked Locked Option",
                                            component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                            screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                            tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                                            tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization,
                                            option_name: "".concat(value, " anchor text suggestions"),
                                            isQwaDashboard: isQwaDashboard
                                        }
                                    });
                                }
                            }
                        // setError('');
                        }
                    }),
                    !qttr_tools_auth && !user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: classes.recaptcha,
                                sitekey: "6LfNnmAqAAAAAFm-6SDC8c9lFenCJX2_QkckWpsd",
                                onChange: handleRecaptchaChange
                            }),
                            (captchaError === null || captchaError === void 0 ? void 0 : captchaError.includes("recaptchaValue")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                className: "red",
                                children: "Please complete the reCAPTCHA to verify you're human."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_11__/* .SkipCaptcha */ .h, {
                                classes: classes,
                                meta: {
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_NAME.anchor_text_generator */ .vG.anchor_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_optimization */ ._V.ai_content_optimization
                                },
                                setShowVerifyEmailPopup: setShowVerifyEmailPopup
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "d-flex ".concat(isCreditsShown ? classes.creditsShown : classes.freeCreditsShown),
                        children: [
                            isCreditsShown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: creditsRemaining,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: usagePerDay
                            }) : !isQwaDashboard || showFreeToolsUsage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: freeToolsUsage,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: isCorpEmail ? 10 : 7,
                                showFreeToolsUsage: showFreeToolsUsage
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "d-flex ".concat(classes.buttonGroup),
                                style: {
                                    marginTop: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                        style: {
                                            float: "right"
                                        },
                                        className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, " ").concat(classes.button),
                                        onClick: function() {
                                            setKeyword("");
                                            setPageURL("");
                                            setGeneratedTitles("");
                                            setNumTags(3);
                                        },
                                        children: "Clear"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                        className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                                        color: "primary",
                                        onClick: function() {
                                            return (0,_utility_common__WEBPACK_IMPORTED_MODULE_9__/* .handleGenerateOutput */ .jx$)(creditsRemaining, creditsNeeded, isQwaDashboard, session, qttr_tools_daypass_auth, setShowMinimumCreditsNeededMsg, setShowBuyOnePass, handleWriteTitleTag, _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_8__/* .trackAnalyticsEvent */ .ec, freeToolsUsage, showFreeToolsUsage);
                                        },
                                        children: "Generate Anchor Text"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnchorTextGenerator);


/***/ })

}]);